import StaffService from '../../apiServices/staff/staffConnect'
import { setStaffConnectDetail } from '../../store/slices/staff/staffConnectSlice';

export function getStaffDetails(
  departmentId : number | undefined
) {
  return async function (dispatch: any, getState: any) {
    let response = await StaffService.getStaffDetails(
     departmentId
    );
    if (response?.success === true) {
      dispatch(setStaffConnectDetail(response.data));
    } else {
      console.log("error");
    }
  };
}